// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import AmenitiesFormController from "./amenities_form_controller"
application.register("amenities-form", AmenitiesFormController)

import AmenitiesOverrideController from "./amenities_override_controller"
application.register("amenities-override", AmenitiesOverrideController)

import NhlTeamLookupController from "./nhl_team_lookup_controller"
application.register("nhl-team-lookup", NhlTeamLookupController)

import PreviewModalController from "./preview_modal_controller"
application.register("preview-modal", PreviewModalController)
